"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Svgs = _interopRequireDefault(require("./Svgs"));
var _classnames = _interopRequireDefault(require("classnames"));
var _excluded = ["name", "className", "classNameContainer", "disabled", "type", "typeStyle", "color", "onClick", "isAction"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var Icons = function Icons(props) {
  var name = props.name,
    className = props.className,
    classNameContainer = props.classNameContainer,
    disabled = props.disabled,
    type = props.type,
    typeStyle = props.typeStyle,
    color = props.color,
    onClick = props.onClick,
    isAction = props.isAction,
    rest = _objectWithoutProperties(props, _excluded);
  var iconClassName = (0, _classnames["default"])({
    "disabled": disabled === true,
    "actionIcon": isAction
  }, type, typeStyle, color, className);
  return /*#__PURE__*/_react["default"].createElement("span", _extends({
    className: "icons-component ".concat(classNameContainer)
  }, rest, {
    onClick: onClick
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "".concat(iconClassName)
  }, (0, _Svgs["default"])(name)));
};
Icons.propTypes = {
  name: _propTypes["default"].string,
  className: _propTypes["default"].string,
  classNameContainer: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  type: _propTypes["default"].oneOf(["glyph", "framed-glyph", "framed-glyph-ext-1", "icon", "framed-icon", "framed-icon-ext-1", "framed-icon-ext-2", "micro-glyph-grape", "micro-glyph-teal"]),
  typeStyle: _propTypes["default"].oneOf(["", "off"]),
  color: _propTypes["default"].oneOf(["", "grape", "red", "silver"]),
  onClick: _propTypes["default"].func,
  isAction: _propTypes["default"].bool
};
Icons.defaultProps = {
  name: "",
  className: "",
  classNameContainer: "",
  disabled: false,
  type: "glyph",
  typeStyle: "",
  color: "",
  onClick: function onClick() {},
  isAction: false
};
var _default = exports["default"] = Icons;